import type { StrokeBrush, StrokeShape } from '../shared/art/types';
import { C } from './paint';

export function drawBrushSample(c: CanvasRenderingContext2D, brush: StrokeBrush, cx: number, cy: number, width: number, brushWidth: number, color: string, shape: StrokeShape = 'circle', shapeFilled = false) {
    const half = Math.max(1.6, Math.min(8, brushWidth / 2)); const span = width / 2;
    c.save(); c.lineCap = brush === 'marker' ? 'butt' : 'round'; c.lineJoin = 'round';
    c.strokeStyle = c.fillStyle = color;
    if (brush === 'outline') {
      c.lineWidth = half * 2; c.beginPath(); c.arc(cx, cy, span * 0.72, 0, Math.PI * 2); c.stroke();
      c.strokeStyle = C.white; c.lineWidth = half * 2 * 0.62; c.beginPath(); c.arc(cx, cy, span * 0.72, 0, Math.PI * 2); c.stroke();
    } else if (brush === 'mirror') {
      c.setLineDash([3, 4]); c.strokeStyle = C.line; c.lineWidth = 1.5;
      c.beginPath(); c.moveTo(cx, cy - span); c.lineTo(cx, cy + span); c.stroke(); c.setLineDash([]);
      c.strokeStyle = color; c.lineWidth = half * 2;
      c.beginPath(); c.moveTo(cx - 3, cy + span * 0.6); c.quadraticCurveTo(cx - span * 0.8, cy - span * 0.2, cx - 4, cy - span * 0.6); c.stroke();
      c.beginPath(); c.moveTo(cx + 3, cy + span * 0.6); c.quadraticCurveTo(cx + span * 0.8, cy - span * 0.2, cx + 4, cy - span * 0.6); c.stroke();
    } else if (brush === 'crayon') {
      c.lineWidth = half * 2;
      for (let i = 0; i < 3; i++) {
        c.globalAlpha = 0.55;
        c.beginPath(); c.moveTo(cx - span, cy - 3 + i * 3); c.lineTo(cx + span, cy - 4 + i * 3); c.stroke();
      }
      c.globalAlpha = 1;
    } else if (brush === 'dash') {
      c.setLineDash([Math.max(3, half * 2.2), Math.max(2.5, half * 1.6)]); c.lineWidth = half * 2;
      c.beginPath(); c.moveTo(cx - span, cy); c.lineTo(cx + span, cy); c.stroke(); c.setLineDash([]);
    } else if (brush === 'spray') {
      // 小样也撒确定性颗粒：和真机上的手感一致，不用文字解释。
      for (let i = 0; i < 26; i++) {
        const a = (i * 2.399) % (Math.PI * 2); const d = Math.sqrt(i / 26) * span * 0.92;
        c.beginPath(); c.arc(cx + Math.cos(a) * d, cy + Math.sin(a) * d, Math.max(0.5, half * 0.36), 0, Math.PI * 2); c.fill();
      }
    } else if (brush === 'glow') {
      c.strokeStyle = color; c.lineCap = 'round';
      for (const ring of [{ scale: 3, alpha: 0.2 }, { scale: 2, alpha: 0.35 }, { scale: 1, alpha: 1 }]) {
        c.globalAlpha = ring.alpha; c.lineWidth = Math.max(1, half * 2 * ring.scale * 0.6);
        c.beginPath(); c.moveTo(cx - span, cy); c.lineTo(cx + span, cy); c.stroke();
      }
      c.globalAlpha = 1;
    } else if (brush === 'ink') {
      // 一笔由粗到细，正是毛笔的速度感。
      for (let i = 0; i < 14; i++) {
        const x0 = cx - span + (span * 2) * (i / 14); const x1 = cx - span + (span * 2) * ((i + 1) / 14);
        c.lineWidth = Math.max(1, half * 2 * (1.35 - 0.85 * (i / 13)));
        c.beginPath(); c.moveTo(x0, cy); c.lineTo(x1, cy); c.stroke();
      }
    } else if (brush === 'shape') {
      c.lineWidth = Math.max(1.4, half * 1.6);
      const r = span * 0.82;
      c.beginPath();
      if (shape === 'rect') c.rect(cx - r, cy - r * 0.78, r * 2, r * 1.56);
      else if (shape === 'triangle') { c.moveTo(cx, cy - r); c.lineTo(cx + r, cy + r * 0.8); c.lineTo(cx - r, cy + r * 0.8); c.closePath(); }
      else c.arc(cx, cy, r * 0.86, 0, Math.PI * 2);
      if (shapeFilled) { c.globalAlpha = 0.45; c.fill(); c.globalAlpha = 1; } else c.stroke();
    } else {
      c.globalAlpha = brush === 'translucent' ? 0.45 : brush === 'marker' ? 0.4 : 1;
      c.lineWidth = half * 2;
      c.beginPath(); c.moveTo(cx - span, cy + (brush === 'line' ? 4 : 0)); c.lineTo(cx + span, cy - (brush === 'line' ? 4 : 0)); c.stroke();
      c.globalAlpha = 1;
      if (brush === 'line') { c.beginPath(); c.arc(cx - span, cy + 4, half, 0, Math.PI * 2); c.fill(); c.beginPath(); c.arc(cx + span, cy - 4, half, 0, Math.PI * 2); c.fill(); }
      if (brush === 'translucent' || brush === 'marker') {
        c.globalAlpha = 0.35; c.beginPath(); c.moveTo(cx - span, cy + 6); c.lineTo(cx + span, cy - 6); c.stroke(); c.globalAlpha = 1;
      }
    }
    c.restore();
}
